import React, { useContext, useEffect, useState } from "react";
import Axios from "axios";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import ReactMarkDown from "react-markdown";
// import defaultPic from "../../resource/profile_pic/depic.png";
import { Form } from "reactstrap";

import { UserContext } from "../../context/UserContext";
import Spinner from "../Spinner";
import MessageFields from "../MessageFields";

const ReadMore = () => {
  const { state } = useContext(UserContext);
  const navigate = useNavigate();

  const initialValue = {
    title: "",
    createdAt: "",
    image: "",
    description: "",
    markdown: "",
    profilepic: "",
    messages: [],
  };

  const [isLoading, setLoading] = useState(true);

  const [blog, setBlog] = useState(initialValue);
  const [isValid, setIsValid] = useState("");

  const params = useParams();
  const id = params.id.toString();

  const setBlogFn = async () => {
    try {
      const res = await Axios.get(
        `https://blogappserver-8sw1.onrender.com/articles/${id}`
      );
      const data = res.data;
      setBlog(data);

      if (!res.status === 200) {
        throw new Error(res.error);
      }
    } catch (error) {}
  };

  const validateArticle = async () => {
    try {
      const res = await Axios.get(
        `https://blogappserver-8sw1.onrender.com/articles/validAuth/${id}`,
        {
          withCredentials: true,
        }
      );
      setIsValid(res.data.isValid);
    } catch (error) {}
  };

  const deleteArtlicleById = async (id) => {
    try {
      const res = await Axios.delete(
        `https://blogappserver-8sw1.onrender.com/articles/${id}`,
        {
          withCredentials: true,
        }
      );
      if (res.status === 200) {
        navigate("/articles");
      } else {
        throw new Error(res.error);
      }
    } catch (error) {}
  };

  const commentOnArticleFn = async ({ text, id }) => {
    try {
      const response = await Axios.put(
        "https://blogappserver-8sw1.onrender.com/articles/comment",
        {
          text: text,
          messageId: id,
        },
        {
          withCredentials: true,
        }
      );
      const updatedMessage = response.data;
      const updatedMessages = [...blog.messages, updatedMessage];
      const updatedBlog = { ...blog, messages: updatedMessages };
      setBlog(updatedBlog);
      // Simulating data loading delay
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);
      window.location.reload();
      navigate(`/articles/${blog._id}`);

      return () => clearTimeout(timer);
    } catch (error) {}
  };

  useEffect(() => {
    const fetchReadMoreFn = async () => {
      await setBlogFn(); //setup articles details
      await validateArticle(); //hide buttons
    };
    fetchReadMoreFn();

    // Simulating data loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clearTextarea = () => {
    const textarea = document.getElementById("text");
    textarea.value = "";
  };

  const { title, createdAt, description, markdown, image } = blog;

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {state ? (
        <>
          <div className="text-center rm-btn">
            <NavLink to={`/articles/edit/${blog._id}`}>
              <button
                hidden={isValid}
                className="btn btn-primary btn-sm px-5 mx-2"
              >
                Edit
              </button>
            </NavLink>

            <button
              type="submit"
              onClick={() => deleteArtlicleById(blog._id)}
              hidden={isValid}
              className="btn btn-danger btn-sm px-5 mx-2"
            >
              Delete
            </button>
          </div>
        </>
      ) : (
        <></>
      )}

      <div className="my-5">
        <div className="rm-margin text-center">
          <h3 className="rm-titlehead mt- 2">{title}</h3>
          <img
            src={blog.user?.profilepic}
            alt="profilepic"
            height={40}
            width={40}
            className="rounded-circle rm-profilepic"
          />
          <span className="text-muted mx-2 mb-5">
            written by{" "}
            <span className="fs-6 text-primary fst-italic">
              {blog.user?.name}
            </span>
            <span className="rm-date">
              {" • "}
              {createdAt}
            </span>
          </span>
        </div>
      </div>
      <div>
        <div className="rm-image">
          <img src={image} alt="blog_image" className="img-rmsize rounded-3" />
        </div>
        <div className="rm-margin text-center">
          <p className="fs-6">{description}</p>
        </div>
        <div className="rm-margin">
          <ReactMarkDown>{markdown}</ReactMarkDown>
        </div>

        <div className="text-center mt-5">
          <p className="text-primary mx-5">
            Like the article? Share it with a friend..!!
          </p>
        </div>
      </div>

      <hr />
      <div className="rm-margin">
        <h5 className="text-center rm-view">Your View's About the Article..</h5>
        {state ? (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              commentOnArticleFn({
                text: e.target.elements[0].value,
                commentOn: e.target.elements[0].value,
                id: blog._id,
              });
            }}
          >
            <div className="card py-3 border-0">
              <div className="d-flex flex-start w-100">
                <img
                  className="rounded-circle me-2"
                  src={state.profilepic}
                  alt="avatar"
                  width="40"
                  height="40"
                />

                <div className="form-outline w-100">
                  <textarea
                    className="form-control"
                    id="text"
                    name="text"
                    rows="3"
                    placeholder="feel free to share your views.."
                  ></textarea>
                </div>
              </div>
              <div className="text-end mt-2">
                <button type="submit" className="btn btn-primary btn-sm mx-2">
                  Post Comment
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => clearTextarea()}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        ) : (
          <>
            <div className="mt-5">
              <div className="row justify-content-center">
                <div className="col">
                  <div className="alert alert-danger text-center" role="alert">
                    <h1 className="display-4">Access Denied</h1>
                    <p className="lead">
                      Oops! You need to log in to access this feature.
                    </p>
                    <p>To read or write comments, please log in.</p>
                    <button
                      className="btn btn-primary btn-lg mt-3"
                      onClick={() => navigate("/login", { replace: true })}
                    >
                      Log In
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {isLoading ? (
          <>
            <Spinner />
          </>
        ) : (
          <MessageFields blog={blog} messages={blog.messages} />
        )}
      </div>
    </>
  );
};

export default ReadMore;

// https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png
